import {action, observable} from 'mobx';
import * as socialApi from '../socialApi';

class PublishingCredentialStore {
  @observable credentials = [];
  @observable isLoading = false;
  initialized = false;

  credentialById(credentialId) {
    this.ensureLoaded()
    return this.credentials.find(x => x._id === credentialId);
  }

  /** Returns all the Social Credentials/Accounts that this user has access and that have access to this listing. */
  getCredentialsForChatterListing = (chatterListing) => {
    this.ensureLoaded()
    if (!chatterListing.credentialIds || !chatterListing.credentialIds.length) return [];
    else {
      return this.credentials.filter(account => chatterListing.credentialIds.includes(account._id));
    }
  };

  allCredentials() {
    this.ensureLoaded();
    return this.credentials;
  }

  @action
  ensureLoaded() {
    if (!this.initialiized) {
      this.isLoading = true
      socialApi.publishingCredentials().then(action(response => {
        this.credentials = response.credentials
        this.isLoading = false
      }))
      this.initialiized = true
    }
  }
}

export default new PublishingCredentialStore();
